var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('restricted',{attrs:{"group":"KaiAdmins"}},[_vm._t("default"),_vm._t("unauthorized",null,{"slot":"unauthorized"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }